import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import { INVOICE_BATCH_NOTE_CATEGORY_LIST_REQUEST, INVOICE_BATCH_NOTE_CATEGORY_LIST_RECEIVED, INVOICE_BATCH_NOTE_CATEGORY_LIST_ERROR } from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const invoiceBatchNoteCategoryListRequest = () => ({
  type: INVOICE_BATCH_NOTE_CATEGORY_LIST_REQUEST,
});

export const invoiceBatchNoteCategoryListReceived = (data) => ({
  type: INVOICE_BATCH_NOTE_CATEGORY_LIST_RECEIVED,
  data,
});

export const invoiceBatchNoteCategoryListError = (error) => ({
  type: INVOICE_BATCH_NOTE_CATEGORY_LIST_ERROR,
  error,
});

export const invoiceBatchNoteCategoryListFetch = () => {
  return (dispatch) => {
    dispatch(invoiceBatchNoteCategoryListRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.INVOICE_BATCH_NOTE_CATEGORY, filters)
      .then((response) => dispatch(invoiceBatchNoteCategoryListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(invoiceBatchNoteCategoryListError(error));
      });
  };
};
